import {
  Button,
  Drawer,
  FieldGroup,
  FieldMessage,
  Icon,
  TextArea,
} from '@teamsnap/teamsnap-ui';
import { createNote } from 'hooks/orderDetails/service';
import * as React from 'react';
import './add-note-sidebar.scss';

type Props = {
  orderId: number;
  show: boolean;
  close: () => void;
  onSubmit: () => void;
};

const AddNoteSidebar = ({ show, close, orderId, onSubmit }: Props) => {
  const [note, setNote] = React.useState('');
  const [caption, setCaption] = React.useState(undefined);

  const onClose = () => {
    setNote('');
    close();
  };

  const onSave = () => {
    if (!note.trim()) {
      setCaption('Required field');
      return;
    }

    createNote(orderId, note).then(() => {
      setNote('');
      onSubmit();
    });
  };

  return (
    <Drawer
      open={show}
      allowOverlayClose={false}
      style={{ maxWidth: '480px', padding: '16px' }}
      mods="add-new-note-drawer u-size12of24"
      showOverlay
      closeFn={() => {}}
      testId="add-new-note--drawer"
    >
      <div className="u-flex u-flexJustifyBetween">
        <p className="u-fontSizeLg" data-testid="add-note-sidebar--msg">
          Add a Note
        </p>
        <Icon
          name="dismiss"
          otherProps={{ id: 'close-sidebar', onClick: onClose }}
          testId="add-note-sidebar--dismiss-icon"
        />
      </div>

      <p
        className="u-spaceEndsMd u-colorGrey"
        data-testid="add-note-sidebar--financial-permission-msg"
      >
        Notes are only viewable to admin users with financial permissions
      </p>

      <FieldGroup status={caption ? 'error' : undefined}>
        <TextArea
          inputProps={{
            className: 'Input',
            placeholder: 'Add a note...',
            style: { height: '120px', width: '100%' },
            value: note,
            onChange: (e) => {
              setCaption(undefined);
              setNote(e.target.value);
            },
          }}
          testId="add-note-sidebar--add-a-note-textarea"
        />
        <FieldMessage status="error">{caption}</FieldMessage>
      </FieldGroup>
      <div className="add-new-note-buttons">
        <Button
          testId="add-note-sidebar--cancel-button"
          mods="u-spaceRightSm"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          testId="add-note-sidebar--save--button"
          mods="Button Button--primary"
          onClick={onSave}
        >
          Save
        </Button>
      </div>
    </Drawer>
  );
};

export default AddNoteSidebar;
